import type {
  AddUserToProgramDTOType,
  CreateProgramSettingsType,
  DoesUserExistsInProgramDTOType,
  DoesUserExistsInProgramResponseType,
  ProgramType,
  UpdateProgramSettingsType,
  UpdateUserEmailInProgramDTOType,
  V1ProgramType,
} from '@/features/programs/types'
import fetchClient from '@/lib/fetch'

export const V1_PROGRAMS_QUERY_KEY = 'v1-programs'
export async function V1GetPrograms(userId?: string): Promise<V1ProgramType[]> {
  // todo remove userId? optional
  if (!userId) {
    return fetchClient('/v1/programs', {
      method: 'GET',
    })
  }
  return fetchClient(`/v1/programs?userId=${userId}`, {
    method: 'GET',
  })
}

export async function doesUserExistsInProgramMutation({
  userId,
  programId,
}: DoesUserExistsInProgramDTOType): Promise<DoesUserExistsInProgramResponseType> {
  return fetchClient(`/v1/programs/${programId}/user/${userId}/exist-in-program`, {
    method: 'GET',
  })
}

export async function addUserToProgramMutation({ userId, programId, roles }: AddUserToProgramDTOType): Promise<void> {
  return fetchClient(`/v1/programs/${programId}/user/`, {
    method: 'POST',
    body: JSON.stringify({ userId, programId, roles }),
  })
}

export async function updateUserRolesInProgramMutation({
  userId,
  programId,
  roles,
}: AddUserToProgramDTOType): Promise<void> {
  return fetchClient(`/v1/programs/${programId}/users/${userId}/roles`, {
    method: 'PUT',
    body: JSON.stringify({ roles }),
  })
}

export async function updateUserEmailInProgramMutation({
  userId,
  programId,
  email,
}: UpdateUserEmailInProgramDTOType): Promise<{ email: string }> {
  return fetchClient(`/v1/programs/${programId}/users/${userId}/email`, {
    method: 'PUT',
    body: JSON.stringify({ email }),
  })
}

/** KC-635 : retire le SSO du compte et envoie l'invitation « Activez votre compte ». */
export async function switchUserToPasswordLoginMutation({
  userId,
  programId,
}: {
  userId: string
  programId: string
}): Promise<{ invitationSent: boolean }> {
  return fetchClient(`/v1/programs/${programId}/users/${userId}/password-login`, {
    method: 'PUT',
  })
}

/** KC-635 : rattache le compte au SSO de la plateforme (mot de passe effacé, aucun mail). */
export async function switchUserToSsoLoginMutation({
  userId,
  programId,
}: {
  userId: string
  programId: string
}): Promise<void> {
  return fetchClient(`/v1/programs/${programId}/users/${userId}/sso-login`, {
    method: 'PUT',
  })
}

export async function createProgramSettingsMutation({
  globalSettings,
  settings,
}: CreateProgramSettingsType): Promise<void> {
  return fetchClient(`/v1/programs/`, {
    method: 'POST',
    body: JSON.stringify({ globalSettings, settings }),
  })
}

/** Réservé à l'équipe Constel (403 sinon). null retire la déclaration. */
export async function updateProgramTypeMutation({
  programId,
  type,
}: {
  programId: string
  type: ProgramType | null
}): Promise<{ programType: ProgramType | null }> {
  return fetchClient(`/v1/programs/${programId}/type`, {
    method: 'PUT',
    body: JSON.stringify({ type }),
  })
}

export async function updateProgramSettingsMutation({
  globalSettings,
  settings,
}: UpdateProgramSettingsType): Promise<void> {
  return fetchClient(`/v1/programs/${globalSettings.programId}`, {
    method: 'PATCH',
    body: JSON.stringify({ globalSettings, settings }),
  })
}
